import BudgetDowload from 'PDF/Presupuesto/BudgetDowload/BudgetDowload';
import BudgetDowloadV2 from 'PDF/PresupuestoV2/BudgetDowload/BudgetDowload';
import BudgetDowloadV3 from 'PDF/PresupuestoV3/BudgetDowload/BudgetDowload';

// Mismo mapeo que BudgetDropdownButton.jsx — extraido para reuso.
export function selectBudgetDownloadComponent(version) {
  const v = Number(version);
  if (v >= 3) return BudgetDowloadV3;
  if (v === 2) return BudgetDowloadV2;
  return BudgetDowload;
}
